// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"e2ff468f85--breadcrumbs--yZfhQ","link":"e2ff468f85--link--mx_s3"};